import React, { useEffect, useState } from 'react';
import { ThemeProvider } from '@mui/material';
import history from 'services/history';
import { theme } from 'config/theme';
import { useWindowSize } from 'hooks/windowSize';
import AppContext, { AppContextData } from 'hooks/app';
import SplashScreen from 'components/loading/SplashScreen';
import AppRoutes from 'routes/Routes';
import { BrowserRouter } from 'routes/BrowserRouter';
import { useAuth } from 'hooks/auth/AuthElement';
import { ToastContainer } from 'react-toastify';
import PermissionRulesProvider from 'hooks/permissionRules';

const App: React.FC = () => {
  const { isMobile, width: windowWidth } = useWindowSize();
  const { logout, isLoading } = useAuth();
  const [isOpenedMenu, setIsOpenedMenu] = useState(!isMobile && windowWidth > 1280);

  function handleOpenMenu() {
    setIsOpenedMenu(!isOpenedMenu);
  }

  const contextValue: AppContextData = {
    isMobile,
    windowWidth,
    handleLogout,
    isOpenedMenu,
    handleOpenMenu,
  };

  function handleLogout() {
    logout();
  }

  return (
    <BrowserRouter history={history}>
      <AppContext.Provider value={contextValue}>
        <ThemeProvider theme={theme}>
          {isLoading ? (
            <SplashScreen />
          ) : (
            <PermissionRulesProvider>
              <AppRoutes />
            </PermissionRulesProvider>
          )}
        </ThemeProvider>
        <ToastContainer position="bottom-left" />
      </AppContext.Provider>
    </BrowserRouter>
  );
};

export default App;
